<template>
    <b-field :label="$t('BUSCACIDADE.CIDADE')" :type="{ 'is-danger': temErros, 'is-success': valido }">
        <b-autocomplete :data="data" field="nome" :value="cidadenome" :loading="isFetching" @typing="getAsyncData" @select="selectCidade">
            <template #empty>
                {{ $t('BUSCACIDADE.NENHUMACIDADE') }}
            </template>
            <template #default="props">
                <div class="is-flex is-justified-between">
                    <span>{{ props.option.nome }}</span>
                    <span class="tag">{{ props.option.estado }}</span>
                </div>
            </template>
        </b-autocomplete>
    </b-field>
</template>

<script>
import debounce from 'lodash/debounce'
import http from '@/http'

export default {
    props: {
        cidadeid: Number,
        cidadenome: String,
        temErros: String,
        valido: Boolean,
    },
    data() {
        return {
            data: [],
            selected: null,
            isFetching: false,
        }
    },
    methods: {
        getAsyncData: debounce(function (name) {
            if (this.selected?.nome === name) return

            this.selected = null
            this.$emit('changed', null)
            this.$emit('selected', null)
            this.$emit('update:cidadeid', null)

            const termo = (name || '').trim()

            if (termo.length < 2) {
                this.data = []
                return
            }

            this.isFetching = true
            http.get('/api/Search/Cidade', { params: { nome: termo } })
                .then(({ data }) => {
                    this.data = Array.isArray(data) ? data : []
                })
                .catch(() => {
                    this.data = []
                    this.$buefy.toast.open({
                        message: 'Não foi possível consultar as cidades.',
                        type: 'is-danger',
                    })
                })
                .finally(() => {
                    this.isFetching = false
                })
        }, 500),

        selectCidade(option) {
            this.selected = option
            this.$emit('changed', option?.id ?? null)
            this.$emit('selected', option ?? null)
            this.$emit('update:cidadeid', option?.id ?? null)
        },
    },
}
</script>
